<script lang="ts">
	//UI
	import { Card } from "@hitit/new_ui";
	import PointNameValue from "./PointNameValue.svelte";
	import PointCategory from "./PointCategory.svelte";
	//Utils
	import { t } from "@hitit/hub/src/stores";
	//Types
	//Props
	export let rewardable = false;
	export let rewardRatio = 0;
	export let expirationInDays = "";
	export let categories: { name: string; rewardable: boolean }[] = [];
	//Constants
	const pointEnableImage = `/img/icons/pointEnable.png`;
	const pointDisableImage = `/img/icons/pointDisable.png`;
	//Variables
	$: rewardableCategories = categories
		.filter((v) => v.rewardable)
		.map((v) => v.name);
	$: nonRewardableCategories = categories
		.filter((v) => !v.rewardable)
		.map((v) => v.name);
	//Functions
	//Do

</script>

<Card>
	<div class="container">
		<div class="point-title-box">
			<img
				class="point-img"
				src={rewardable ? pointEnableImage : pointDisableImage}
				alt={rewardable ? 'pointEnable' : 'pointDisable'} />
			<div class="point-title" class:textcolor={rewardable}>
				{rewardable ? $t('mbr.point.point_use_store') : $t('mbr.point.point_unused_store')}
			</div>
		</div>
		<PointNameValue
			tid={'ratio'}
			name={$t('mbr.point.points_accumulation_rate')}
			text={rewardable ? rewardRatio + ' %' : '-'} />
		<PointNameValue
			tid={'period'}
			name={$t('mbr.point.point_validity_period')}
			text={rewardable ? expirationInDays : '-'} />
		<PointCategory
			tId={'enable'}
			pointIsUsed={rewardable}
			name={$t('mbr.point.earning_category')}
			category={rewardableCategories} />
		<PointCategory
			tId={'disable'}
			pointIsUsed={rewardable}
			name={$t('mbr.point.non-earning_category')}
			category={nonRewardableCategories} />
	</div>
</Card>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		display: flex;
		flex-direction: column;
		gap: 20px;
		width: 100%;

		.point-title-box {
			display: flex;
			align-items: center;

			.point-title {
				font-size: 1.25rem;
				font-weight: 600;
				letter-spacing: -0.8px;
				color: #6d6f76;
				padding-left: 10px;
			}
			.textcolor {
				color: #6591fa;
			}
		}
		.point-img {
			width: 30px;
		}
	}

	@include DesktopSize {
		.container {
			.point-title-box {
				align-items: flex-start;
				.point-title {
					font-size: 2.1875rem;
				}
			}
			.point-img {
				width: 40px;
				height: 40px;
			}
		}
	}

</style>
